module.exports = __webpack_public_path__ + "img/ic-ic-now-cho-pop.799e167b.svg";